import{styled as t,modifier as o,css as i}from"@lokalise/styled";import{value as e}from"../../../utils/theme/index.js";const n=t.div.withConfig({displayName:"MenuList__Container",componentId:"sc-1hb10dt-0"})(["width:max-content;z-index:",";"," &&&&:focus{outline:none !important;}"],e("zIndex.popover"),o("$fullWidth",i`
			width: 100%;
		`));export{n as Container};
//# sourceMappingURL=styles.js.map
